
 
import React, { useEffect } from 'react'
import Event from './eventImg/event-30-dec.webp'


const Event29 = () => {
    useEffect(() => {
        document.title = "ISHRAE Knowledge Talk on The Role  of Filtration in Pharma";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>30 December 2025</h1>
        <h3 className='text-center'>ISHRAE Knowledge Talk on The Role  of Filtration in Pharma  </h3>
</div>
   <div className='container' id='calanderevent'>
    <img src={Event} alt='ISHRAE Knowledge Talk on The Role  of Filtration in Pharma'/>
     <button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/bkslsvZga2RK65Y=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event29




